(()=>{
const stars=(scope=document)=>scope.querySelectorAll('.pwl [data-stars]').forEach(el=>{el.innerHTML=Array(5).fill('<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/></svg>').join('');});
stars();
document.addEventListener('shopify:section:load',()=>stars());
if (!customElements.get('gwp-countdown')) {
  class GwpCountdown extends HTMLElement {
    connectedCallback() {
      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');
      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    getTarget() {
      const intervalHours = { daily: 24, half_day: 12, quarter_day: 6 }[this.dataset.timerMode];
      if (intervalHours) {
        const ms = intervalHours * 36e5;
        return new Date((Math.floor(Date.now() / ms) + 1) * ms);
      }
      return new Date(this.dataset.target);
    }
    tick() {
      const diff = this.getTarget() - Date.now();
      if (!(diff > 0)) {
        this.hidden = true;
        return;
      }
      this.hoursEl.textContent = String(Math.floor(diff / 36e5)).padStart(2, '0');
      this.minutesEl.textContent = String(Math.floor((diff % 36e5) / 6e4)).padStart(2, '0');
      this.secondsEl.textContent = String(Math.floor((diff % 6e4) / 1e3)).padStart(2, '0');
    }
  }
  customElements.define('gwp-countdown', GwpCountdown);
}
if (!customElements.get('gwp-gallery')) {
  class GwpGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gallery-track');
      this.slides = [...this.querySelectorAll('.gallery-slide')];
      this.dots = [...this.querySelectorAll('.gwp-dot')];
      this.current = 0;
      this.total = this.slides.length;
      this.interval = parseInt(this.dataset.autoplayInterval) || 4000;
      this.querySelector('.gallery-btn--prev')?.addEventListener('click', () => this.go(this.current - 1));
      this.querySelector('.gallery-btn--next')?.addEventListener('click', () => this.go(this.current + 1));
      this.dots.forEach(dot => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index))));
      this.startAutoplay();
      let startX = 0;
      this.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) this.go(this.current + (diff > 0 ? 1 : -1));
      }, { passive: true });
    }
    go(index) {
      this.current = ((index % this.total) + this.total) % this.total;
      this.track.style.transform = `translateX(-${this.current * 100}%)`;
      this.dots.forEach((d, i) => {
        d.classList.remove('active');
        if (i === this.current) { void d.offsetWidth; d.classList.add('active'); }
      });
      this.startAutoplay();
    }
    startAutoplay() {
      clearInterval(this._timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this._timer = setInterval(() => this.go(this.current + 1), this.interval);
    }
    disconnectedCallback() { clearInterval(this._timer); }
  }
  customElements.define('gwp-gallery', GwpGallery);
}
if (!customElements.get('gwp-sticky-cta')) {
 class GwpStickyCta extends HTMLElement {
  connectedCallback() {
   this._init = this._init.bind(this);
   this._schedule = () => {
    if (!this._frame) this._frame = requestAnimationFrame(() => this._update());
   };
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._init, {once:true});
   else this._init();
  }
  _init() {
   this._page = document;
   if (!this._page || this._listening) return;
   this._listening = true;
   this._hero = this._page.querySelector('.gwp-hero__btn');
   this._offer = document.querySelector('[data-pwl-offer]');
   this._finalCta = this._page.querySelector('.gwp-reviews__cta-wrap');
   window.addEventListener('scroll', this._schedule, {passive:true});
   window.addEventListener('resize', this._schedule);
   window.visualViewport?.addEventListener('resize', this._schedule);
   if (typeof ResizeObserver !== 'undefined') {
    this._resize = new ResizeObserver(this._schedule);
    this._resize.observe(document.documentElement);
    this._resize.observe(this);
   }
   this._update();
  }
  _update() {
   this._frame = 0;
   const viewportHeight = window.innerHeight;
   const hero = this._hero?.getBoundingClientRect();
   const offer = this._offer?.getBoundingClientRect();
   const finalCta = this._finalCta?.getBoundingClientRect();
   const pastHero = !hero || hero.bottom <= 0;
   const offerVisible = offer && offer.bottom > -80 && offer.top < viewportHeight + 80;
   const buffer = window.innerWidth < 992 ? this.offsetHeight + 24 : 24;
   const finalVisible = finalCta && finalCta.bottom > -24 && finalCta.top < viewportHeight + buffer;
   this.classList.toggle('stuck', Boolean(pastHero && !offerVisible && !finalVisible));
  }
  disconnectedCallback() {
   window.removeEventListener('scroll', this._schedule);
   window.removeEventListener('resize', this._schedule);
   window.visualViewport?.removeEventListener('resize', this._schedule);
   document.removeEventListener('DOMContentLoaded', this._init);
   this._resize?.disconnect();
   if (this._frame) cancelAnimationFrame(this._frame);
   this._listening = false;
  }
 }
 customElements.define('gwp-sticky-cta', GwpStickyCta);
}

if (!customElements.get('gwp-review-carousel')) {
  class GwpReviewCarousel extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.gwp-reviews');
      this.track = this.querySelector('.gwp-reviews__track');
      this.slides = [...this.querySelectorAll('.gwp-reviews__card-wrap')];
      this.dots = [...root.querySelectorAll('.gwp-reviews__dot')];
      this.prevBtn = root.querySelector('[data-dir="prev"]');
      this.nextBtn = root.querySelector('[data-dir="next"]');
      this.current = 0;
      this.total = this.slides.length;
      this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
      this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));
      this.dots.forEach(d => d.addEventListener('click', () => this.go(parseInt(d.dataset.index))));
      let startX = 0;
      this.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) this.go(this.current + (diff > 0 ? 1 : -1));
      }, { passive: true });
      window.addEventListener('resize', () => this.go(this.current));
    }
    go(i) {
      if (window.innerWidth >= 992) { this.track.style.transform = ''; return; }
      this.current = Math.max(0, Math.min(i, this.total - 1));
      const slideW = (this.slides[0]?.offsetWidth || 0) + 16;
      this.track.style.transform = `translateX(-${this.current * slideW}px)`;
      this.dots.forEach((d, idx) => d.classList.toggle('active', idx === this.current));
    }
  }
  customElements.define('gwp-review-carousel', GwpReviewCarousel);
}
})();
